var BettingGatewayConfigurations = /** @class */ (function () {
    function BettingGatewayConfigurations(param) {
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
    }
    return BettingGatewayConfigurations;
}());
export { BettingGatewayConfigurations };
//# sourceMappingURL=BettingGatewayConfigirations.js.map